export default "__VITE_ASSET__2JTvPYjV__"